import { Eyebrow, Reveal } from "@/components/site/Reveal";
import { InstagramEmbed } from "@/components/media/InstagramEmbed";

const REELS = [
  "https://www.instagram.com/reel/Db-GiSAzVvD/",
  "https://www.instagram.com/reel/Dc-yxH_gZ5l/",
];

const InstagramReels = () => (
  <section className="py-32 md:py-44" data-testid="instagram-reels" aria-labelledby="reels-heading">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="max-w-3xl">
        <Reveal><Eyebrow>Straight from Instagram</Eyebrow></Reveal>
        <Reveal delay={0.05}>
          <h2 id="reels-heading" className="mt-7 font-display uppercase text-4xl sm:text-5xl lg:text-7xl tracking-tight leading-[0.95] text-[#2E1B16]">
            Reels we made<br />for real clients.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 text-lg md:text-xl text-[#2E1B16]/60 leading-relaxed max-w-md">
            Two different businesses, two different stories. Watch them exactly as they run in the feed.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 md:mt-24 grid md:grid-cols-2 gap-10 md:gap-8 justify-items-center" data-testid="instagram-reels-grid">
        {REELS.map((url) => (
          <InstagramEmbed key={url} className="w-full" url={url} />
        ))}
      </div>
    </div>
  </section>
);

export default InstagramReels;
